<template>
  <div>
    <div>
      <div class="custom-accordion">
        <div class="accordion-header" @click="toggleAccordion">
          <h5 class="d-flex justify-content-between align-items-center">
            <span>
              {{ __("forms.EvaluationChart.questions.questions_setting.question42.totalSumPrizeFinal") }}
            </span>
            <i :class="isAccordionOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="accordion-icon"></i>
          </h5>
        </div>
        <div class="accordion-content" :class="{ 'accordion-open': isAccordionOpen }">
          <div class="accordion-body">
            <div v-if="!showLoading && summaryPlansTable.length > 0" class="custom-table">
              <!-- Header Row -->
              <div class="row table-header">
                <div class="col-9 font-weight-bold">
                  {{ __("forms.EvaluationChart.questions.questions_setting.question42.plan") }}
                </div>
                <div class="col-3 text-center font-weight-bold">
                  {{ __('forms.EvaluationChart.questions.questions_setting.question12.tableKPI.bonus_rep') }}
                </div>
              </div>

              <!-- Data Rows -->
              <div v-for="(planSummary, index) in summaryPlansTable" :key="index" class="row table-row">
                <div class="col-9">
                  {{ planSummary.name }}
                </div>
                <div class="col-3 text-center">
                  {{ planSummary.final_prize_formatted }}
                </div>
               
              </div>

              <!-- Total Row -->
              <div class="row table-row table-total">
                <div class="col-9 text-left font-weight-bold">
                  {{ __('misc.total') }}
                </div>
                <div class="col-3 text-center font-weight-bold">
                  {{ totalRow.final_prize_formatted }}
                </div>
                
              </div>
            </div>
            <p v-else-if="!showLoading" class="w-100 text-center mt-5">
              {{ __('forms.EvaluationChart.questions.questions_setting.question42.no_data_available') }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="showLoading">
        <p class="w-100 text-center mt-5">
          <i class="fa-solid fa-spinner fa-spin-pulse"></i> {{ __('misc.loading') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {

    this.populatePlansTable();
  },
  props: {

    evaluation_chart_id: {
      type: Number,
      required: true,
    },

    question_survey_id: {
      type: Number,
      required: true,
    },

    owner_person_id: {
      type: Number,
      required: true,
    },
    workflow_role_id: {
      type: Number,
      required: false,
      default: null
    },

  },
  data() {
    return {
      summaryPlansTable: [],
      totalRow: {},
      showLoading: true,
      isAccordionOpen: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),


    };
  },
  methods: {

    refreshSummatyTable() {
      this.populatePlansTable();
    }, 

    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen;
    },

    populatePlansTable() {

      this.showLoading = true;
      axios
        .get("/summary-list-kpis-incentive-plans-final-prizes-user", {
          params: {
            'question42[workflow_role_id]': this.workflow_role_id,
            'question42[owner_person_id]': this.owner_person_id,
            'question42[question_survey_id]': this.question_survey_id,
            'question42[evaluation_chart_id]': this.evaluation_chart_id,
          }
        })
        .then((response) => {
          this.showLoading = false;
          this.summaryPlansTable = response.data.summaryPlansTable;
          this.totalRow = response.data.totalRow;
        })
        .catch(function (error) {
          alert(error);
        });

    },

  },
};
</script>

<style scoped>
/* Accordion Styles */
.custom-accordion {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  overflow: hidden;
}

.accordion-header {
  background-color: #f8f9fa;
  padding: 1rem;
  cursor: pointer;
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
}

.accordion-header:hover {
  background-color: #e9ecef;
}

.accordion-header h5 {
  margin: 0;
  font-weight: 600;
  color: #495057;
}

.accordion-icon {
  transition: transform 0.3s ease;
  color: #6c757d;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease;
}

.accordion-content.accordion-open {
  max-height: 1000px;
  /* Sufficiently large value */
}

.accordion-body {
  padding: 1rem;
}

/* Smooth icon rotation */
.accordion-open+.accordion-header .accordion-icon {
  transform: rotate(180deg);
}

/* Custom Table Styles */
.custom-table {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  overflow: hidden;
}

.table-header {
  margin: 0;
  background-color: #1766a1;
  color: white;
  padding: 0.25rem 0;
  border-bottom: none;
}

.table-header .col-1,
.table-header .col-3,
.table-header .col-9 {
  padding: 0.25rem 1rem !important;
  border-right: none;
}


.table-row {
  margin: 0;
  padding: 0.25rem 0;
  border-bottom: 1px solid #dee2e6;
}

.table-row:nth-child(even) {
  background-color: #f8f9fa;
}

.table-row .col-1,
.table-row .col-3,
.table-row .col-9 {
  padding: 0.25rem 1rem;
  border-right: none;
}


.table-total {
  background-color: #1766a1 !important;
  color: white !important;
  font-weight: bold !important;
  border-bottom: none;
}

.table-total .col-1,
.table-total .col-3,
.table-total .col-9 {
  background-color: #1766a1 !important;
  color: white !important;
  padding: 0.25rem 1rem !important;
}
</style>
